import { Badge, Select } from "../../ui/index.ts";

export const INVITATION_STAGES = [
  { value: "FORM_PENDING", label: "Candidate Pending" },
  { value: "AGENCY_PENDING", label: "Agency Pending" },
  { value: "IT_PENDING", label: "IT Pending" },
  { value: "HR_PENDING", label: "HR Pending" },
  { value: "COMPLETED", label: "Completed" },
] as const;
export type InvitationStage = "ALL" | typeof INVITATION_STAGES[number]["value"];
export function InvitationStageFilter({ id, value, onChange, includeAgencyPending = false }: { id: string; value: InvitationStage; onChange: (value: InvitationStage) => void; includeAgencyPending?: boolean }) {
  return <Select id={id} label="Select Status" value={value} options={[{ value: "ALL", label: "All" }, ...INVITATION_STAGES.filter((stage) => includeAgencyPending || stage.value !== "AGENCY_PENDING")]} onChange={(next) => onChange(next as InvitationStage)} />;
}

export function InvitationStageBadge({ stage }: { stage?: string | null }) {
  const label = INVITATION_STAGES.find((option) => option.value === stage)?.label ?? (stage ? stage.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase()) : "Not available");
  return <Badge variant={stage === "COMPLETED" ? "success" : "warning"}>{label}</Badge>;
}
